export default "__VITE_ASSET__34af445e__"